import { handleChannelDeactivated } from './channel-deactivated';

export const channelHandlers = () => [handleChannelDeactivated()];
